/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Price_Include2_TitleInputs */

const es_landing_price_include2_title = /** @type {(inputs: Landing_Price_Include2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestión de reservas online`)
};

const gl_landing_price_include2_title = /** @type {(inputs: Landing_Price_Include2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xestión de reservas en liña`)
};

const en_landing_price_include2_title = /** @type {(inputs: Landing_Price_Include2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online booking management`)
};

/**
* | output |
* | --- |
* | "Online booking management" |
*
* @param {Landing_Price_Include2_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_price_include2_title = /** @type {((inputs?: Landing_Price_Include2_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Price_Include2_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_price_include2_title(inputs)
	if (locale === "en") return en_landing_price_include2_title(inputs)
	return es_landing_price_include2_title(inputs)
});